import MODULE from './module';

export default {
  SNACKBAR_MANAGEMENT: `@${MODULE}/SNACKBAR_MANAGEMENT`,
};
